"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorRateTable = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../../../../common");
const DSTL001DetailStyled_1 = require("./DSTL001DetailStyled");
const popup_1 = require("../../../../base/popup");
const i18next_1 = __importDefault(require("i18next"));
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
function formatNumber(value) {
    const formattedValue = value.toFixed(1); // Format the number to two decimal places
    if (formattedValue.endsWith('00')) {
        return parseInt(formattedValue, 10); // Convert to integer if no decimal part
    }
    if (formattedValue.endsWith('0')) {
        return parseFloat(formattedValue.slice(0, -1)); // Remove trailing zero if exists
    }
    return parseFloat(formattedValue); // Return the formatted value with up to two decimals
}
exports.ErrorRateTable = react_1.default.memo(({ hardest, showMore = false }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isTablet, isMobile, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [page, setPage] = (0, react_1.useState)(0);
    const [testData, setTestData] = (0, react_1.useState)([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const openPopup = (hardest) => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: exports.ErrorRateTable,
            componentProps: { showMore: true, hardest },
            width: 1200,
            height: isTablet && 'unset',
            title: i18next_1.default.t('assignment.errorRate'),
            isFit: false,
        });
    };
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        // 기본적인 항목들
        const headTitleList = [
            { title: 'rankings', space: 1, sort: false },
            { title: 'questionNumbers', space: 1.5, sort: false },
            ...(!showMore ? [] : [{ title: 'title', space: 2 }]),
            { title: 'errorRates', space: 2, sort: false },
            {
                title: 'choiceRatios',
                space: 6,
                sort: false,
                children: ['1번', '2번', '3번', '4번', '5번'],
            },
        ];
        const tableReadDataKeys = [
            { title: 'rankings', space: 1 },
            { title: 'number', space: 1.5 },
            ...(!showMore ? [] : [{ title: 'subject_item', space: 2 }]),
            { title: 'incorrect_rate', space: 2 },
            { title: 'distribution', space: 6 },
        ];
        // useMemo에서 반환
        return { headTitleList, tableReadDataKeys };
    }, []);
    react_1.default.useEffect(() => {
        if (!hardest)
            return;
        if (hardest && hardest.length < 0) {
            setTestData([]);
            setTotalCount(0);
            return;
        }
        const data = showMore ? hardest : hardest.slice(0, 5);
        const list = data.sort((a, b) => b.incorrect_rate - a.incorrect_rate);
        setTestData(list);
        setTotalCount(list.length);
    }, [hardest, showMore]);
    const handlerMoreData = () => {
        setPage(prevPage => prevPage + 1);
    };
    const renderItem = (item, styles, index) => {
        return tableReadDataKeys.map(headItem => (react_1.default.createElement("div", { key: headItem.title, className: "flex row body-item", style: {
                flex: headItem.space,
                ...styles?.bodyItem,
                overflow: 'hidden',
                gap: `${headItem.title === 'distribution' ? '20px' : ''}`,
                ...(headItem.title === 'number'
                    ? { flexDirection: 'column', gap: 12 }
                    : {}),
            } }, headItem.title === 'distribution' ? (Array.isArray(item[headItem.title]) && item[headItem.title].length === 0 ? (react_1.default.createElement("p", { className: "overText", style: { ...styles?.bodyText, flex: 1, textAlign: 'center' } }, "-")) : (item[headItem.title].map((choice, index) => (react_1.default.createElement("p", { key: index, className: "overText", style: { ...styles?.bodyText, flex: 1, textAlign: 'center' } },
            formatNumber(choice),
            "%"))))) : (react_1.default.createElement("p", { className: "overText", style: styles?.bodyText }, headItem.title === 'rankings'
            ? index + 1
            : headItem.title === 'incorrect_rate'
                ? `${formatNumber(item[headItem.title])}%`
                : item[headItem.title])))));
    };
    const renderMobileItem = (item, styles, index) => {
        return tableReadDataKeys.map(headItem => headItem.title === 'rankings' || headItem.title === 'number' ? null : (react_1.default.createElement("div", { key: headItem.title, className: "flex row body-item", style: {
                flex: headItem.space,
                ...styles?.bodyItem,
                overflow: 'hidden',
                gap: `${headItem.title === 'distribution' ? '20px' : ''}`,
            } }, headItem.title === 'distribution' ? (react_1.default.createElement("div", { className: "ratio" },
            react_1.default.createElement("div", { className: "choice-ratio-text" }, t('assignment.choiceRatios')),
            react_1.default.createElement("div", { className: "choice-ratio-wrap", style: {
                    display: 'flex',
                    width: '100%',
                } }, Array.isArray(item[headItem.title]) && item[headItem.title].length === 0 ? (react_1.default.createElement("p", { className: "overText", style: { ...styles?.bodyText, flex: 1, textAlign: 'center', alignContent: 'center' } }, "-")) : (item[headItem.title].map((choice, index) => {
                return (react_1.default.createElement("div", { key: index, style: {
                        width: '100%',
                    } },
                    react_1.default.createElement("div", { className: "choice-ratio-index" },
                        index + 1,
                        "\uBC88"),
                    react_1.default.createElement("p", { key: index, className: "overText", style: {
                            ...styles?.bodyText,
                            flex: 1,
                            textAlign: 'center',
                        } },
                        formatNumber(choice),
                        "%")));
            }))))) : headItem.title === 'incorrect_rate' ? (react_1.default.createElement("div", { className: "error-info-wrap" },
            react_1.default.createElement("div", { className: "error-frame" },
                react_1.default.createElement("div", { className: "error-rate-text" }, t('assignment.questionNumbers')),
                react_1.default.createElement("div", { className: "overText" },
                    item['number'],
                    t('assignment.number'))),
            react_1.default.createElement("div", { className: "error-frame" },
                react_1.default.createElement("div", { className: "error-rate-text" }, t('assignment.errorRates')),
                react_1.default.createElement("div", { className: "overText" }, `${formatNumber(item[headItem.title])}%`)))) : (react_1.default.createElement("p", { className: "overText", style: styles?.bodyText }, item[headItem.title])))));
    };
    return (react_1.default.createElement(DSTL001DetailStyled_1.DSTL001DetailTableStyled, { "$isMobile": isMobile, "$isTablet": isTablet, className: `field-global-001 detail_table ${showMore && !isMobile ? 'popup-table' : ''} `, style: { flexDirection: 'column' } },
        !showMore && (react_1.default.createElement("div", { className: "task-label", style: {
                width: '100%',
                alignItems: 'space-between',
                minHeight: 'min-content',
            } },
            react_1.default.createElement("p", { className: "error-rate-txt" }, t('assignment.errorRate')),
            react_1.default.createElement("p", { className: "detail_txt", onClick: () => openPopup(hardest) }, t('assignment.showAllErrRate')))),
        react_1.default.createElement("div", { className: "fext-field" },
            react_1.default.createElement(common_1.Table, { className: isMobile
                    ? showMore
                        ? 'task-list-mobile task-list-mobile-popup'
                        : 'task-list-mobile'
                    : 'task-list-002', showIndex: false, isInfinite: true, page: page, data: testData, sortDefault: "member_id", totalCount: totalCount, headTitleList: headTitleList, styles: isMobile
                    ? {}
                    : {
                        headWrapper: {
                            justifyContent: 'center',
                            alignItems: 'center',
                        },
                        headItem: {
                            alignItems: 'center',
                            justifyContent: 'center',
                        },
                        bodyItem: {
                            alignItems: 'center',
                            justifyContent: 'center',
                        },
                    }, renderItem: isMobile ? renderMobileItem : renderItem, handlerMoreData: handlerMoreData, forceShowheader: isMobile ? false : true }))));
});
